__turbopack_context__.v({
  "blockTwoColumn": "BlockTwoColumnImage-module-scss-module__2DbTkq__blockTwoColumn",
  "blockTwoColumnFlex": "BlockTwoColumnImage-module-scss-module__2DbTkq__blockTwoColumnFlex",
  "blockTwoColumnReversed": "BlockTwoColumnImage-module-scss-module__2DbTkq__blockTwoColumnReversed",
  "buttonWrapper": "BlockTwoColumnImage-module-scss-module__2DbTkq__buttonWrapper",
  "column": "BlockTwoColumnImage-module-scss-module__2DbTkq__column",
  "contactHeadline": "BlockTwoColumnImage-module-scss-module__2DbTkq__contactHeadline",
  "contactsText": "BlockTwoColumnImage-module-scss-module__2DbTkq__contactsText",
  "copy": "BlockTwoColumnImage-module-scss-module__2DbTkq__copy",
  "cta": "BlockTwoColumnImage-module-scss-module__2DbTkq__cta",
  "flushBottom": "BlockTwoColumnImage-module-scss-module__2DbTkq__flushBottom",
  "flushTop": "BlockTwoColumnImage-module-scss-module__2DbTkq__flushTop",
  "headline": "BlockTwoColumnImage-module-scss-module__2DbTkq__headline",
  "image": "BlockTwoColumnImage-module-scss-module__2DbTkq__image",
  "lockup": "BlockTwoColumnImage-module-scss-module__2DbTkq__lockup",
  "multiButton": "BlockTwoColumnImage-module-scss-module__2DbTkq__multiButton",
  "richHeadline": "BlockTwoColumnImage-module-scss-module__2DbTkq__richHeadline",
  "richParagraph": "BlockTwoColumnImage-module-scss-module__2DbTkq__richParagraph",
  "richUnorderedList": "BlockTwoColumnImage-module-scss-module__2DbTkq__richUnorderedList",
  "secondaryHeadline": "BlockTwoColumnImage-module-scss-module__2DbTkq__secondaryHeadline",
  "theme--dark": "BlockTwoColumnImage-module-scss-module__2DbTkq__theme--dark",
});
